import { useQuery } from 'hooks/useCustomQuery';
import getEngine from 'API/Engines/getEngine';

const useGetEngine = (engineId, enabled = true) => {
    return useQuery({
        queryKey: ['Engine', engineId],
        queryFn: async () => {
            const response = await getEngine(engineId);
            return response.data;
        },
        enabled: enabled && !!engineId,
        staleTime: 5 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });
};

export default useGetEngine;
